import React, { useEffect, useState } from "react";
import { Route, Routes } from "react-router-dom";
import RestaurantRoutes from "./components/RestaurantRoutes/RestaurantRoutes";
import ContactUs from "./components/MainPageWebsite/ContactUs/ContactUs";
import HomePage from "./components/MainPageWebsite/HomePage/HomePage";
import PrivacyPolicy from "./components/MainPageWebsite/PrivacyPolicy/PrivacyPolicy";
import TermsOfService from "./components/MainPageWebsite/TermsOfService/TermsOfService";
import { Bounce, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { indexStore } from "./store/indexStore";
import OrderSuccess from "./components/MainPageWebsite/OrderSuccess/OrderSuccess";
import OrderFailed from "./components/MainPageWebsite/OrderFailed/OrderFailed";
import NotFound from "./components/MainPageWebsite/NotFound/NotFound";
import DeleteAccountGuide from "./components/MainPageWebsite/DeleteAccountGuide/DeleteAccountGuide";
import Branches from "./components/Branches/Branches";

function App() {
  const [isRTL, setIsRTL] = useState(false);
  const { fetchBranchesAction, settings, fetchSettingsAction } = indexStore();

  useEffect(() => {
    const lang = localStorage.getItem("Lang") || "ar";
    setIsRTL(lang === "ar");

    // الاستماع لتغييرات اللغة
    const handleStorageChange = () => {
      const currentLang = localStorage.getItem("Lang") || "ar";
      setIsRTL(currentLang === "ar");
    };

    window.addEventListener("storage", handleStorageChange);
    return () => window.removeEventListener("storage", handleStorageChange);
  }, []);
  useEffect(() => {
    fetchBranchesAction();
    // جلب الإعدادات إذا لم تكن موجودة
    if (!settings || Object.keys(settings).length === 0) {
      fetchSettingsAction();
    }
  }, [fetchBranchesAction, fetchSettingsAction, settings]);

  return (
    <div>
      <Routes>
        <Route path="/" Component={HomePage} />
        <Route path="/contact" Component={ContactUs} />
        <Route path="/privacy-policy" Component={PrivacyPolicy} />
        <Route path="/terms-of-service" Component={TermsOfService} />
        <Route path="/delete-account" Component={DeleteAccountGuide} />
        <Route path="/order/success" Component={OrderSuccess} />
        <Route path="/order/failed" Component={OrderFailed} />
        <Route path="/branches/*" Component={RestaurantRoutes} />
        <Route path="/branches" Component={Branches} />
        <Route path="*" Component={NotFound} />
      </Routes>
      <ToastContainer
        position="top-center"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
        transition={Bounce}
        toastClassName="!bg-card !border-2 !border-border !rounded-xl !shadow-xl !backdrop-blur-sm"
        bodyClassName="!text-foreground !font-medium"
        progressClassName="!bg-primary"
        closeButton={false}
        rtl={isRTL}
      />
    </div>
  );
}

export default App;
